import { Injectable } from '@angular/core';

@Injectable()
export class TaskConstantsService {

  constructor() { }

  public static ApiConstants = {
    getTask: 'api/task/configuration/gettasksection',
    saveTask: 'api/task/savetask',
    getTaskList: 'api/task/configuration/gettasklist',
    getCheckList: 'api/task/configuration/getchecklist',
    getMonitoringMatrix: 'api/task/getMonitoringMatrix',
    GetTaskById: 'api/task/get/gettaskbyid',
    ExportToExcelTaskList: 'api/task/ExportToExcelTaskList',
    DownloadPDF: 'api/task/get/downloadpdf',
    DownloadZIP: 'api/task/get/downloadzip',
    updateTask: 'api/task/updateTask',
  };

  public static MultiSelectStatus = [
    { label: 'Submitted', value: 'Submitted' }
  ];
  public static TaskNavigation = {
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Task Setup',
        routeURL: '/task/task',
        isClickable: true
      },
      {
        routeName: 'Task Overview',
        routeURL: '/task/task-list',
        isClickable: true
      },
      {
        routeName: 'Monitoring Matrix',
        routeURL: '/task/monitoring-matrix',
        isClickable: true
      },
    ],
    ReportRoutes: []
  };
  // Routing URL
  public static RoutingURLConstant = {
    MyTaskOverview: '/task/task-list',
  };
  public static ColumnNames = {
    CreatedDate: 'CreatedDate',
    DESC: 'DESC',
    ASC: 'ASC',
    TaskId: 'TaskId'
  }
  public static Status = {
    New: 'New',
    Cancelled: 'Cancelled',
    Deleted: 'Deleted',
    Draft:'Draft'
  }
}
